import { useState } from 'react';
import { Button, Typo } from '@geberit/gdds';

// styles
import styles from './sidebar.module.scss';

// components
import { Translation } from 'components/Translation/Translation';
import { Image } from 'components/image/image';
import SidebarItemProduct from './sidebar-item-product';
import SidebarItemFullAdress from './sidebar-item-full-adress';
import SidebarItemEvent from './sidebar-item-event';
import { HotelDetail } from './detail/hotel/hotel-detail';
import { ShowroomDetail } from './detail/showroom/showroom-detail';
import { ProductDetail } from './detail/product/product-detail';
import { EventDetail } from './detail/event/event-detail';

// utils
import { formatDistance } from 'utils/locator';
import { svgMarker } from '../svg-marker';
import { useThemeName } from 'utils/hooks/use-theme';
import { THEME_NAMES } from 'themes';

const componentMap = {
  product: SidebarItemProduct,
  event: SidebarItemEvent,
  showroom: SidebarItemFullAdress,
  hotel: SidebarItemFullAdress,
};

const detailComponentMap = {
  product: ProductDetail,
  event: EventDetail,
  showroom: ShowroomDetail,
  hotel: HotelDetail,
};

type Item = { category: string; distance?: number; color?: string };

type SidebarItemProps = {
  item: Item;
  mode: string;
  showDistance: boolean;
  handleDetail: any;
  retrieveColor: (category: string) => string | null;
};

function SidebarItem({
  item,
  item: { category, distance },
  mode,
  showDistance,
  retrieveColor,
  handleDetail,
}: Readonly<SidebarItemProps>) {
  const [openAcc, setOpenAcc] = useState(false);
  const ItemView = componentMap[mode];
  const DetailView = detailComponentMap[mode];
  const isNordics = useThemeName() === THEME_NAMES.NORD;

  function getIcon(color: string | null) {
    return `data:image/svg+xml;base64,${svgMarker(color || '#26513B')}`;
  }

  const handleMoreClick = () => {
    setOpenAcc(!openAcc);
    handleDetail(item, true);
  };

  const buttonTranslation = openAcc ? 'web20_locator_less_details' : 'web20_locator_more_details';
  const buttonSymbol = openAcc ? 'chevron_up' : 'chevron_down';
  const defaultColor = isNordics ? '#6c906e' : '#004673';
  const color = category ? retrieveColor(category) : defaultColor;

  return (
    <ul className={styles.listItem}>
      <div className={styles.itemInfo}>
        <div className={styles.generalInfoWrapper}>
          <div className={styles.generalInfo}>
            <ItemView item={item} />
          </div>
          {showDistance && Boolean(distance) && (
            <div className={styles.distanceInfo}>
              <Image src={getIcon(color)} alt={category} title={category} staticImage />
              <Typo
                variant="p2"
                tag="span"
                {...(isNordics && { size: { xsmall: ['0.9375rem', '2rem'] } })}
              >
                {formatDistance(distance)} <Translation id="web20_locator_distance_unit" />
              </Typo>
            </div>
          )}
        </div>
        <DetailView isAcc isNord item={item} openAcc={openAcc} />
        <div className={styles.additionalInfo}>
          <Button
            alignByContent="left"
            stylingType="flatHighlight"
            onClick={handleMoreClick}
            symbol={buttonSymbol}
          >
            <Translation id={buttonTranslation} />
          </Button>
        </div>
      </div>
    </ul>
  );
}

export default SidebarItem;
